<template>
	<v-tooltip :attach="overlayTarget" location="start" v-if="props.params.tooltip">
		<template v-slot:activator="{ props: activatorProps }">
			<span v-bind="activatorProps" @click.stop="props.params.onClick(props.params.key)">
				<md-icon class="grid-icon">{{ props.params.icon }}</md-icon>
			</span>
		</template>
		<span>{{ props.params.tooltip }}</span>
	</v-tooltip>
	<md-icon v-else class="grid-icon" @click="props.params.onClick(props.params.key)">{{ props.params.icon }}</md-icon>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
	params: {
		required: true,
		type: Object,
		tooltip: String,
		icon: String,
		key: String,
		onClick: Function,
	},
});
const overlayTarget = inject('overlayTarget', null);
</script>

<style lang="scss">
.grid-icon {
	cursor: pointer;
}
</style>
